import React from "react";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionEatingDisorder({
  eatingDisorderVomitingLaxatives,
  handleEatingDisorderVomitingLaxativesChange,
  eatingDisorderFoodConsumption,
  handleEatingDisorderFoodConsumptionChange,
  bodyHeight,
  handleBodyHeightChange,
  eatingDisorderDiagnosis,
  handleEatingDisorderDiagnosisChange,
}) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title-2B">
        Potential eating disorder/issues
      </div>

      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="Have you ever vomited or used laxatives to lose weight or purge food you have eaten?"
          value={eatingDisorderVomitingLaxatives}
          onChange={handleEatingDisorderVomitingLaxativesChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="Do you consume a small amount of food (i.e., less than 1200 calories/day) on a regular basis to influence your shape or weight? "
          value={eatingDisorderFoodConsumption}
          onChange={handleEatingDisorderFoodConsumptionChange}
          showValidation={true}
        />
        <TextFieldComponentLarge
          title="(if yes, ask for height and body weight"
          width="300"
          value={bodyHeight}
          onChange={handleBodyHeightChange}
        />
        <TextFieldComponentLarge
          title="Have you ever been diagnosed with an eating disorder?"
          value={eatingDisorderDiagnosis}
          onChange={handleEatingDisorderDiagnosisChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionEatingDisorder;

